<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const tabs = computed(() => [
  {
    id: 'principal',
    icon: 'i-heroicons-home-solid',
    label: t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.PRINCIPAL'),
    routeName: 'operacao_imobiliaria_corretor',
  },
  {
    id: 'comissao',
    icon: 'i-heroicons-currency-dollar-solid',
    label: t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.COMMISSION'),
    routeName: 'operacao_imobiliaria_corretor',
  },
  {
    id: 'investimentos',
    icon: 'i-heroicons-wallet-solid',
    label: t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.INVESTMENTS'),
    routeName: 'operacao_imobiliaria_corretor_investimentos',
  },
  {
    id: 'ajuda',
    icon: 'i-heroicons-lifebuoy-solid',
    label: t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.HELP'),
    routeName: 'operacao_imobiliaria_corretor_ajuda',
  },
]);

const queryValue = value => (Array.isArray(value) ? value[0] : value);
const activeTab = computed(() => {
  if (route.name === 'operacao_imobiliaria_corretor_investimentos') {
    return 'investimentos';
  }
  if (route.name === 'operacao_imobiliaria_corretor_ajuda') return 'ajuda';
  return queryValue(route.query?.section) === 'comissao'
    ? 'comissao'
    : 'principal';
});

const navigate = tab => {
  const query = tab.id === 'comissao' ? { section: 'comissao' } : {};
  router.push({
    name: tab.routeName,
    params: { accountId: route.params.accountId },
    query,
  });
};
</script>

<template>
  <nav
    class="fixed inset-x-0 bottom-0 z-40 grid grid-cols-4 border-t border-lais-border-soft bg-white/95 pb-2 pt-1 shadow-lais-card backdrop-blur md:hidden"
    :aria-label="t('REAL_ESTATE_BROKER_DASHBOARD.MOBILE_NAV.ARIA')"
  >
    <button
      v-for="tab in tabs"
      :key="tab.id"
      type="button"
      class="flex min-h-14 flex-col items-center justify-center gap-1 text-[11px] font-semibold transition"
      :class="
        activeTab === tab.id
          ? 'text-lais-primary'
          : 'text-lais-text-muted hover:text-lais-text'
      "
      :aria-current="activeTab === tab.id ? 'page' : undefined"
      @click="navigate(tab)"
    >
      <span
        :data-testid="`broker-mobile-nav-icon-${tab.id}`"
        class="box-content grid size-5 place-items-center rounded-[10px] px-[10px] py-1 transition"
        :class="activeTab === tab.id ? 'bg-[#EDF8F7] text-[#01988C]' : ''"
        aria-hidden="true"
      >
        <span class="size-5" :class="tab.icon" />
      </span>
      <span>{{ tab.label }}</span>
    </button>
  </nav>
</template>
